import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-fullscreen-exit",
  templateUrl: "./med-icon-fullscreen-exit.component.html",
})
export class MedIconFullscreenExitComponent extends SvgMixinComponent {}
